import { render } from "./NewSurveyQuestionModal.vue?vue&type=template&id=2d4fedfc&scoped=true"
import script from "./NewSurveyQuestionModal.vue?vue&type=script&lang=js"
export * from "./NewSurveyQuestionModal.vue?vue&type=script&lang=js"

import "./NewSurveyQuestionModal.vue?vue&type=style&index=0&id=2d4fedfc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d4fedfc"],['__file',"src/components/survey/NewSurveyQuestionModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d4fedfc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d4fedfc', __exports__)) {
    api.reload('2d4fedfc', __exports__)
  }
  
  module.hot.accept("./NewSurveyQuestionModal.vue?vue&type=template&id=2d4fedfc&scoped=true", () => {
    api.rerender('2d4fedfc', render)
  })

}


export default __exports__